import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EnvelopeSimple, House, List, Note, Truck, Users } from 'phosphor-react'

import { PATHS } from '@/consts/paths'
import { collectCountRequest } from '@/store/modules/users/collections/reducer'

import { useProfile } from '@/hooks'
import { MenuItem } from '../MenuItem'
import { CommonMenuItems } from './Common'

// -------------------------------------

export function CustomerMenuItems() {
  const profile = useProfile()

  const dispatch = useDispatch()

  const collectCount = useSelector((state) => state.users.collections.count)
  const collect = useSelector((state) => state.users.collections.active.collect)

  useEffect(() => {
    dispatch(collectCountRequest())
  }, [dispatch, collect])

  return (
    <>
      <MenuItem Icon={House} label="Home" path={PATHS.user.home} />

      <MenuItem
        Icon={List}
        label="Pedidos"
        path={PATHS.user.ordersForCollect}
      />

      <MenuItem
        Icon={Truck}
        label="Coleta"
        path={PATHS.user.collect}
        badgeContent={collectCount}
      />

      <MenuItem
        Icon={EnvelopeSimple}
        label="Emitidas"
        path={PATHS.user.issueds}
      />

      <MenuItem Icon={Note} label="Consultas" path={PATHS.user.queries.root} />

      <CommonMenuItems />

      {profile.isAdminUser && (
        <MenuItem Icon={Users} label="Usuários" path={PATHS.admin.users} />
      )}
    </>
  )
}
